import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import fetchAPI from "../../../common/fetchAPI";
import { WebHookStateClass } from "./interfaces/WebHookStateClass";
import { RootState } from "../../../app/store";

const initialState: WebHookStateClass = {
    isLoading: false,
    WebHookList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: '',
    pageNo: 1,
    startRec: 0,
    sortOrder: 'asc',
    sortColumn: '1',
    recordsFiltered: 0,
    SystemWebHookEventTypesList: [],
    WebHookSubscriptionWithDetailList: [],
    WebHookSubscriptionWithDetailObject: {
        AccountWebhookSubscriptionID: "00000000-0000-0000-0000-000000000000",
        SystemWebHookSourceId: "00000000-0000-0000-0000-000000000000",
        WebHookName: "",
        TargetURL: "",
        IsActive: true,
        WebHookEntries: []
    },
    WebhookSubscriptionCheckedIds: [],
    isSort:false,
    isSearch:false,
    isReloadForIsDisabled:false,
};


interface IThunkApi {
    state: {
        webHook: WebHookStateClass
    }
}
export const getAccountWebHookSubscriptionsForApiByAccountIdAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "WebHook/v2/getAccountWebHookSubscriptionsForApiByAccountId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/WebHooks/AccountSubcriptions", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const getSystemWebHookEventTypesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "WebHook/v2/getSystemWebHookEventTypes",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/WebHooks/GetWebHookEventTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
// export const getAccountWebHookAsync = createAsyncThunk
//     <any, any, IThunkApi>
//     (
//         "WebHook/v2/getAccountWebHook",
//         async (arg, thunkApi) => {
//             const { currentPage, pageSize, start, search, order, orderDir } = arg;

//             const response = await fetchAPI("api/v2/WebHooks/WebHooksDatatable/" + start + '/' + pageSize + '/' + currentPage + '/' + order + '/' + (orderDir === undefined ? '' : orderDir) + '/' + search, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
//             const json = await response.json();
//             return json;
//         }
//     )
export const getAccountWebHookAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "WebHook/v2/getAccountWebHook",
        async (arg, thunkApi) => {
            const { startRec,pageSize,pageNo,sortColumn,sortOrder, search } = thunkApi.getState().webHook;
            const response = await fetchAPI(`api/V2/WebHooks/WebHooksDatatable/${startRec}/${pageSize}/${pageNo}/${sortColumn}/${sortOrder}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;
       
        }
    )
export const getAccountWebHookByAccountWebHookSubscriptionIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "WebHook/v2/getAccountWebHookByAccountWebHookSubscriptionId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/WebHooks/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const addAccountWebHookSubscriptionAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHook/v2/addAccountWebHookSubscription',
        async (arg, thunkApi) => {
          
            const response = await fetchAPI('api/v2/WebHooks/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountWebHookSubscriptionAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHook/v2/updateAccountWebHookSubscription',
        async (arg, thunkApi) => {

            const { AccountWebhookSubscriptionID, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/WebHooks/' + AccountWebhookSubscriptionID, 'POST', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
    export const updateIsDisabledAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHook/v2/updateIsDisabled',
        async (arg, thunkApi) => {

            const { AccountWebhookSubscriptionID, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/WebHooks/' + AccountWebhookSubscriptionID, 'POST', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountWebHookSubscriptionAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "WebHook/v2/deleteAccountWebHookSubscription",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/WebHooks/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const DeleteSelectedAccountWebHookSubscriptionAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "WebHook/v2/DeleteSelectedAccountWebHookSubscription",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/WebHooks/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const webHookSlice = createSlice({
    name: "WebHook",
    initialState,
    reducers: {
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
        },
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
            state.SystemWebHookEventTypesList = []
            state.WebHookSubscriptionWithDetailObject = {
                AccountWebhookSubscriptionID: "00000000-0000-0000-0000-000000000000",
                SystemWebHookSourceId: "00000000-0000-0000-0000-000000000000",
                WebHookName: "",
                TargetURL: "",
                IsActive: true,
                WebHookEntries: []
            }
            state.WebhookSubscriptionCheckedIds = []
        },
        checkedStateById: (state, action) => {
            state.SystemWebHookEventTypesList.map((si: any, index: any) => {
                const currentindex = state.SystemWebHookEventTypesList[index].Items.findIndex((item: any) => item.SystemWebHookEventTypeID == action.payload);
                if (currentindex > -1) {
                    const newArray = [...state.SystemWebHookEventTypesList[index].Items];
                    newArray[currentindex] = { ...newArray[currentindex], Checked: true };
                    state.SystemWebHookEventTypesList[index].Items = newArray
                }
            })
        },
        checkedState: (state, action) => {
            action.payload.map((i: any) => {
                state.SystemWebHookEventTypesList.map((si: any, index: any) => {
                    const currentindex = state.SystemWebHookEventTypesList[index].Items.findIndex((item: any) => item.SystemWebHookEventTypeID == i.SystemWebHookEventTypeId);
                    if (currentindex > -1) {
                        const newArray = [...state.SystemWebHookEventTypesList[index].Items];
                        newArray[currentindex] = { ...newArray[currentindex], Checked: true };
                        state.SystemWebHookEventTypesList[index].Items = newArray
                    }
                })
            })
        },
        
        unCheckedState: (state, action) => {
            state.SystemWebHookEventTypesList.map((si: any, index: any) => {
                const currentindex = state.SystemWebHookEventTypesList[index].Items.findIndex((item: any) => item.SystemWebHookEventTypeID == action.payload);

                if (currentindex > -1) {
                    const newArray = [...state.SystemWebHookEventTypesList[index].Items];
                    newArray[currentindex] = { ...newArray[currentindex], Checked: false };
                    state.SystemWebHookEventTypesList[index].Items = newArray
                }
            })
        },
        checkedListState: (state, action) => {
            const currentindex = state.WebHookList.findIndex((item) => item.AccountWebhookSubscriptionID == action.payload);
            const newArray = [...state.WebHookList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.WebHookList = newArray;
            state.WebhookSubscriptionCheckedIds.push(newArray[currentindex].AccountWebhookSubscriptionID);

        },
        unCheckedListState: (state, action) => {
            const currentindex = state.WebHookList.findIndex((item) => item.AccountWebhookSubscriptionID == action.payload);
            const newArray = [...state.WebHookList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.WebHookList = newArray;
            state.WebhookSubscriptionCheckedIds = state.WebhookSubscriptionCheckedIds.filter(item => item !== newArray[currentindex].AccountWebhookSubscriptionID);
        },
        checkedAllState: (state) => {
            const newArray = state.WebHookList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.WebHookList = newArray;
            state.WebHookList.map((i) => {
                if (!state.WebhookSubscriptionCheckedIds.includes(i.AccountWebhookSubscriptionID)) {
                    state.WebhookSubscriptionCheckedIds.push(i.AccountWebhookSubscriptionID)
                }
                
            });
            
        },
        unCheckedAllState: (state) => {
            const newArray = state.WebHookList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.WebHookList = newArray;
            state.WebhookSubscriptionCheckedIds = [];
         
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            
        },
        // updatePagination: (state, action: PayloadAction<any>) => {
        //     state.currentPage = action.payload.pageNumber;
        //     state.startRec = action.payload.startRec;
        //     state.start = action.payload.start;
        //     state.pageNo = action.payload.pageNo;
        //     state.search = action.payload.search;
        //     state.isReload = true;
        // },
        // updateSearchPagination: (state, action: PayloadAction<any>) => {
            
        //     state.search = action.payload;
        // },
        setPageSize: (state, action) => {
        state.pageSize = action.payload;
           
         },
         setSearchValue: (state, action) => {

            state.search = action.payload;
            state.currentPage = 1;
            state.isSearch = true;
        },
        // updateSorting: (state, action: PayloadAction<any>) => {
        //     state.sortOrder = action.payload.sortOrder;
        //     state.sortColumn = action.payload.sortColumn;
        //     state.startRec = action.payload.startRec;
        //     state.pageSize = action.payload.pageSize;
        //     state.pageNo = action.payload.pageNo;
        // }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getAccountWebHookSubscriptionsForApiByAccountIdAsync.pending, (state) => {
            state.status = "loading";
            state.isLoading = true;

        })
        .addCase(getAccountWebHookSubscriptionsForApiByAccountIdAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isLoading = false;
            state.WebhookSubscriptionCheckedIds = [];
            payload.map((i:any) => {
                    state.WebhookSubscriptionCheckedIds.push(i.AccountWebhookSubscriptionID)
            });
        })
        
        .addCase(getAccountWebHookSubscriptionsForApiByAccountIdAsync.rejected, (state) => {
            state.status = "failed";
            state.isLoading = false;

        })

            .addCase(getSystemWebHookEventTypesAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;

            })
            .addCase(getSystemWebHookEventTypesAsync.fulfilled, (state, { payload }) => {

                state.status = "idle";
                state.isLoading = false;
                state.SystemWebHookEventTypesList = payload.data;
                state.WebHookSubscriptionWithDetailObject.WebHookEntries = payload.aliasedList;
            })
            .addCase(getSystemWebHookEventTypesAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;
            })

            .addCase(getAccountWebHookAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountWebHookAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (Object.keys(payload.data).length === 0) {
                    state.WebHookList = [];
                } else {
                    state.WebHookList = JSON.parse(payload.data);
                    state.WebHookList.map((item: any) => {
                        if(state.WebhookSubscriptionCheckedIds.includes(item.AccountWebhookSubscriptionID))
                        {
                            item.isSelected = 1
                        }
                        else
                        {
                            item.isSelected = 0
                        }
                    });
                }
                
                state.isReload = false;
                state.selectedRecord = {};
                // state.currentPage = payload.currentPage;
                // state.start = payload.start
                // state.totalItems = payload.recordsTotal;
                // state.search = payload.search;
                // state.recordsFiltered = payload.recordsFiltered;
                // state.pageSize = payload.pageSize;
                state.isSearch = false;
                state.isLoading = false;
                state.isReloadForIsDisabled = false;
                state.pageNo = payload.currentPage; 
                state.startRec = payload.start;
                state.totalItems =payload.recordsTotal;
                state.search = payload.search;
                state.recordsFiltered = payload.recordsFiltered;
                state.pageSize = payload.pageSize;


            })
            .addCase(getAccountWebHookAsync.rejected, (state) => {
                state.status = "failed";
                state.isSearch = false;
                state.isLoading = false;
            })

            .addCase(getAccountWebHookByAccountWebHookSubscriptionIdAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;

            })
            .addCase(getAccountWebHookByAccountWebHookSubscriptionIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.selectedRecord = payload;
                
            })
            .addCase(getAccountWebHookByAccountWebHookSubscriptionIdAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;

            })

            .addCase(addAccountWebHookSubscriptionAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountWebHookSubscriptionAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(addAccountWebHookSubscriptionAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(updateAccountWebHookSubscriptionAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountWebHookSubscriptionAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(updateAccountWebHookSubscriptionAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(updateIsDisabledAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateIsDisabledAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReloadForIsDisabled = true;
            })
            .addCase(updateIsDisabledAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            

            .addCase(deleteAccountWebHookSubscriptionAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountWebHookSubscriptionAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(deleteAccountWebHookSubscriptionAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(DeleteSelectedAccountWebHookSubscriptionAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountWebHookSubscriptionAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                state.WebhookSubscriptionCheckedIds = [];
            })
            .addCase(DeleteSelectedAccountWebHookSubscriptionAsync.rejected, (state) => {
                state.WebhookSubscriptionCheckedIds = [];
                state.status = 'failed';
                state.isLoading = false;
            })

    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedStateById,
     checkedListState, unCheckedListState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,
      updatePagination, updateSearchPagination,updateSorting, setSearchValue,setPageSize } = webHookSlice.actions
export const webHookState = (state: RootState) => state.webHook
export default webHookSlice.reducer